$(function() {
	var supportIndexSwiper = new Swiper("#support-index-swiper", {
		slidesPerView: 2,
		   breakpoints: {
			// PC 端
			768: {
				slidesPerView: 3
			}
			},
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},
	});
	var getStartedSwiperAuto = new Swiper("#getStartedSwiperAuto", {
		pagination: {
			el: ".swiper-pagination"
		},
	}); 
	var getStartedTipDummyText = new Swiper("#getStartedTipDummyText", {
		pagination: {
			el: ".swiper-pagination"
		},
	}); 
	var getStartedSwiper2 = new Swiper("#getStartedSwiper2", {
		pagination: {
			el: ".swiper-pagination"
		},
	});
	$('#supportIndexSwiperPreBtn').click(function() {
		supportIndexSwiper.slidePrev();
	})
	$('#supportIndexSwiperNextBtn').click(function() {
		supportIndexSwiper.slideNext();
	})
	$("#androidBtn").click(function(){
		$(this).addClass("and");
		$("#iosBtn").removeClass("and");
		$("#iosPlant").hide("slow");
		$("#androidPlant").show("slow");
	});	
	$("#iosBtn").click(function(){
		$(this).addClass("and");
		$("#androidBtn").removeClass("and");
		$("#androidPlant").hide("slow");
		$("#iosPlant").show("slow");
	});	
	
	new Swiper("#support-index2-swiper", {
		slidesPerView: 1,
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	type: "fraction",
		// },
		pagination: {
            el: '.support-index2-swiper-pagination',
            clickable: true,
        },
		navigation: {
            nextEl: '#supportIndexSwiperPreBtnCopy',
            prevEl: '#supportIndexSwiperNextBtnCopy',
        },
	});
	$('#supportIndexSwiperPreBtn').click(() => {
		$('#supportIndexSwiperPreBtnCopy').trigger("click")
	})
	$('#supportIndexSwiperNextBtn').click(() => {
		$('#supportIndexSwiperNextBtnCopy').trigger("click")
	})
	
	$("#androidBtn").click(function(){
		$(this).addClass("and");
		$("#iosBtn").removeClass("and");
		$("#iosPlant").hide("slow");
		$("#androidPlant").show("slow");
	});	
	$("#iosBtn").click(function(){
		$(this).addClass("and");
		$("#androidBtn").removeClass("and");
		$("#androidPlant").hide("slow");
		$("#iosPlant").show("slow");
	});	
	
	$(".collspan-item").click(function(){
		console.log(111)
		if($(this).hasClass("active")){
			$(this).removeClass("active");
		}
		else{
			$(".collspan-item").removeClass("active");
			$(this).addClass("active");
		}
		
	});
	
	$("#solutionNoBtn").click(function(){
		$("#trouble4").show("")
	});
	     
	$("#closeRegisterBtnImg").click(function(){
		$("#register4").removeClass("show");
	}); 
	$("#showGuoqiList").click(function(){
		if($(".guoqiList").css("display") == "block"){
			$(".guoqiList").hide();  
		}
		else{
			$(".guoqiList").show();  
		}
	});   
	$(".showGuoqiList").click(function(){
		if($(".guoqiList").css("display") == "block"){
			$(".guoqiList").hide();  
		}
		else{
			$(".guoqiList").show();  
		}
		 
	});  
	$("#serialNumTipsImg").click(function(){
		$("#register4").addClass("show");
	});
	$(".guoqiList .guoqiItem").click(function(){
		$(".guoqiList").hide();   
		var country = $(this).data("country");
		$("#country").val(country);
		$("#guoqiImg").attr("src",$(this).find("img").attr("src"));
		$("#guojiaXianshi").html($(this).find("p").html());
		
	});
	$("#registerOtherBtn").click(function(){
		$("#registerOther").hide();
		$("#registerProdBox").show();  
	});
	
	$("#choiceHowToWork .item").click(function(){
		$("#choiceHowToWork .item").removeClass("focus");
		$(this).addClass("focus");
		var itemId = $(this).attr("itemId");
		if(itemId =="first"){
			$("#nowMsgClain2").hide();
			$("#nowMsgClain1").show();
		}
		else{
			$("#nowMsgClain2").show();
			$("#nowMsgClain1").hide();
		}
	});
	var api_base_usercenter = "https://us-ucenter.tineco.com";
	$("#submitClaim").click(function(){
		$(this).attr("disabled","disabled");
		var email = $("#email").val();
		var name = $("#name").val();
		var mobile = $("#mobile").val();
		var orderNo = $("#order").val();
		var productmodel = $("#productmodel").val();
		var serialNumber = $("#serialNumber").val();
		var address = $("#address").val();
		var country = $("#country").val();
		var territory = $("#territory").val();
		var city = $("#city").val();
		var zipCode = $("#zipCode").val();
		var issueType = $("#issueType").val();
		var msg = $("#msg").val();
		var re = /^\w+(?:\.\w+){0,1}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,4}){1,2}$/;
		if(!email){
			layer.msg("Email field is required.");
			$("#email").focus();
			$(this).removeAttr("disabled");
			return false;
		}
		if(!re.test(email)){
			$("#email").addClass("error");
			layer.msg("Please enter a valid email address.");
			$(this).removeAttr("disabled");
			$("#email").focus();
			return false;
		}
		if(!name){
			$("#name").addClass("error");
			layer.msg("Contact Name field is required.");
			$(this).removeAttr("disabled");
			$("#name").focus();
			return false;
		}
		if(!orderNo){
			layer.msg("Order field is required.");
			$("#order").focus();
			$("#orderNo").addClass("error");
			$(this).removeAttr("disabled");
			return false;
		}
		if(!productmodel){
			layer.msg("Product model field is required.");
			$("#productmodel").focus();
			$("#productmodel").addClass("error");
			$(this).removeAttr("disabled");
			return false;
		}
		if(!serialNumber){
			layer.msg("Serial Number field is required.");
			$("#serialNumber").focus();
			$("#serialNumber").addClass("error");
			$(this).removeAttr("disabled");
			return false;
		}
		if(!msg){
			layer.msg("Issue Details field is required.");
			$("#msg").focus();
			$("#msg").addClass("error");
			$(this).removeAttr("disabled");
			return false;
		}
		if(imgList.length < 1){
			layer.msg("Attachment field is required.");
			$("#msg").addClass("error");
			$(this).removeAttr("disabled");
			return false;
		}
		$.ajax({			
			url: api_base_usercenter + "/member/v1/product/register-product/check-sn?sn="+serialNumber,
			type: "get",
			dataType: "json",
			contentType: "application/json",
			success: function(res) {
				if('200'== res.code && res.data){
					$.post("https://mgr-gjgw.tineco.com/mapi/m/siteapi/saveClaim",{
						email:email,
						name:name,
						mobile:mobile,
						orderNo : orderNo,
						productModel:productmodel,
						serialNumber:serialNumber,
						address:address,
						country:country,
						territory:territory,
						city:city,
						zipCode:zipCode,
						issueType:issueType,
						msg:msg,
						imgList:imgList.join(","),
						siteId:"1",
						domain:document.domain
					},function(json){
						if(json.code == 0){
							$("#email").val("");
							$("#name").val("");
							$("#mobile").val("");
							$("#order").val("");
							$("#productmodel").val("");
							$("#serialNumber").val("");
							$("#address").val("");
							$("#country").val("");
							$("#territory").val("");
							$("#city").val("");
							$("#zipCode").val("");
							$("#issueType").val("");
							$("#msg").val("");
							 $("#imgListBox").empty();
							$("#submitClaim").removeAttr("disabled");
							layer.open({
							  title: 'Information'
							  ,content: 'Submit Successfully!'
							,btn:'OK',
							});
						}
						else{
							$("#submitClaim").removeAttr("disabled");
							layer.open({
							  title: 'Error'
							  ,content: json.msg
							,btn:'OK',
							});
							return false;
						}
					},"json");
				}
				else{
					$("#serialNumber").addClass("error");
					layer.open({
					  title: 'Error'
					  ,content: 'Serial Number is not valid.'
					,btn:'OK',
					});
					$("#submitClaim").removeAttr("disabled");
					return false;

				}
			},
			error: function(res) {
				$("#serialNumber").addClass("error");
				layer.open({
				  title: 'Error'
				  ,content: 'Serial Number is not valid.'
				,btn:'OK',
				});
				$("#submitClaim").removeAttr("disabled");
				return false;
			}
		})
		
	});
	
});
